<template>
  <div class="video-page">
    <div class="video">
      <div class="title">
        {{ videoName }}
      </div>
      <div class="video-box">
        <video id="player-container" class="video-js" controls fluid>
        </video>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "@/components/Footer.vue";
import videojs from 'video.js';
import {Toast} from 'mint-ui';
import {Resource} from "@/services/resource";

export default {
  components: {Footer},
  data() {
    return {
      id: '',
      videoName: ''
    }
  },
  mounted() {
    const id = this.$route.query.id;
    Resource.promotionDetail.post({}, {
      id,
      platform: 1
    }).then(res => {
      this.videoName = res.data.title;
      if (res.data.content) {
        const player = videojs('player-container');
        player.src(res.data.content);
      } else {
        Toast({message: "视频不存在！", position: "middle"});
      }
    })
  },
  methods: {}
}
</script>
<style lang="less" scoped>
.video-page {
  height: 800px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .video {
    height: 100%;
  }

  .title {
    font-weight: bolder;
    font-size: 20px;
    margin-bottom: 40px;
    margin-top: 40px;
    margin-left: 80px;
  }

  .video-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
